import { Vue, Component } from "vue-property-decorator";
import RequestButton from '@/components/request-button/index.vue';
import TrialButton from '@/components/trial-button/index.vue';

@Component({
  components: {
    RequestButton,
    TrialButton
  }
})

export default class PageLFK extends Vue {}